import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import UserColumn from '../../../../commonComponents/lists/columns/UserColumn';
import List from '../../../../commonComponents/lists/List';
import CountryColumn from './CountryColumn';
import StatusColumn from './StatusColumn';
import ConditionColumn from './ConditionColumn';
import ActionsColumn from './ActionsColumn';

function LeadsList({ t, challengeId }) {
  const columns = [
    {
      field: 'company',
      title: t('challengeDetails_company'),
    },
    {
      field: 'country',
      title: t('challengeDetails_country'),
      sortable: false,
      template: row =>
        renderToStaticMarkup(<CountryColumn country={row.country} />),
    },
    {
      field: 'user',
      title: t('challengeDetails_creator'),
      sortable: false,
      template: row =>
        renderToStaticMarkup(<UserColumn t={t} user={row.user} />),
    },
    {
      field: 'owner',
      title: t('challengeDetails_owner'),
      sortable: false,
      template: row =>
        row.owner
          ? renderToStaticMarkup(<UserColumn user={row.owner} />)
          : '- -',
    },
    {
      field: 'endDate',
      sortable: true,
      title: t('challengeDetails_endDate'),
      textAlign: 'center',
      width: 100,
    },
    {
      field: 'condition',
      sortable: true,
      title: t('challengeDetails_leadCondition'),
      template: row =>
        renderToStaticMarkup(
          <ConditionColumn t={t} condition={row.condition} />,
        ),
    },
    {
      field: 'status',
      sortable: true,
      title: t('challengeDetails_leadStatus'),
      template: row =>
        renderToStaticMarkup(<StatusColumn t={t} status={row.status} />),
    },
    {
      field: 'actions',
      sortable: false,
      title: '',
      width: 40,
      template: row =>
        renderToStaticMarkup(
          <ActionsColumn t={t} url={`/challenges/leads/${row._id}`} />,
        ),
    },
  ];

  const dataTransform = lead => ({
    ...lead,
    endDate: moment.utc(lead.endDate).format('DD MMM, YY'),
  });

  return (
    <List
      dataSourceURL="/challenges/leads"
      dataTransform={dataTransform}
      dataSourceParams={{ game: challengeId }}
      columns={columns}
      id="leadsList"
      query={{}}
    />
  );
}

LeadsList.propTypes = {
  t: PropTypes.func.isRequired,
  challengeId: PropTypes.string.isRequired,
};

export default translate(LeadsList);
